import { render, staticRenderFns } from "./TheBottomMenu.vue?vue&type=template&id=7ed298f5"
import script from "./TheBottomMenu.vue?vue&type=script&lang=js"
export * from "./TheBottomMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports